import React from "react";
import clsx from "clsx";

type ButtonProps = {
  onClick?: () => void;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "card" | "danger" | "success" | "chat"; // Add more variants as needed
};

export const Button: React.FC<ButtonProps> = ({ onClick, children, variant = "primary" }) => (
  <button
    onClick={onClick}
    className={clsx("flex items-center justify-center rounded-md px-4 py-2", {
      "bg-gray-900 text-white hover:bg-gray-700": variant === "primary",
      "bg-gray-200 text-gray-900 hover:bg-gray-300": variant === "secondary",
      "border border-desert-sand-900 bg-desert-sand-900 text-white hover:bg-midnight-blue-600 hover:text-desert-sand-300":
        variant === "card",
      "bg-red-600 text-white hover:bg-red-500": variant === "danger",
      "bg-green-600 text-white hover:bg-green-500": variant === "success",
      "bg-desert-sand-300 text-midnight-blue-700 hover:bg-midnight-blue-800 hover:text-ivory-mist-200":
        variant === "chat",
    })}
  >
    {children}
  </button>
);
